const Selectors = {
  widget: {
    target: "#selfbook_sdkwidget > div",
    waitFor: "#rewards_benefit_signup, #rewards_benefit_signup_footer",
    mobileWidgetTarget: "#rewards_benefit_signup, #rewards_benefit_signup_footer",
    widgetDesktop: "#gustbook-widget-desktop",
    widget: "#guestbook-widget",
    stickyWidget: "#guestbook-sticky-widget",
  },
  ratesPage: {
    waitFor: ".rewards_benefit_rate-wrapper",
    title: "div[data-testid='sb-screen-header'] h2",
    contentChangeTarget: '#sb-room-title, [data-testid="pricing"] > div:nth-child(2) > div > div, .payment-summary-wrapper',
    rates: ".rewards_benefit_rate-wrapper",
    ratesCodes: ".rewards_benefit_rate-wrapper",
    ratesMessage: ".gb-rates-message", 
    currency: "NA",
    ratesModalButton: '#sb-rate-trigger-MEMBER-text',
    modalClose: 'Button[aria-label="Close Price Breakdown"]',
    modalHotelRates: 'div > div > [data-testid="accordion-panel"] > div > div > dl dd',
  },
  paymentPage: {
    waitFor: "#rewards_benefit_terms, #Email", // #rewards_benefit_total, #Email",
    contentChangeTarget: '.payment-summary-wrapper',
    currency: "NA",
    checkin: "NA",
    checkout: "NA",
    cartTarget: "NA",
    firstname: "#firstname",
    lastname: "#lastname",
    email: "#Email",
    seeDetail: 'button:contains("See detail")',
    modalSubtotal: 'dt:contains("Total, excl. fees")',
    pricePerNightDropdown: '#sb-modalcontent button:contains("Price Per Night")',
    subtotalBackup: '#sb-modalcontent dt',
    subtotal: '[data-testid="expandable-panel"] > div > div > div > dl > dl:first-child > dd',
    total: "NA",
    closePriceModal: 'button[aria-label="Close Price Breakdown"]',
    enrollmentTarget: "#rewards_benefit_terms",
    rewardsMessageTarget: "NA",
    saveInfoTarget: "NA",
    enrollmentMessageContainer: "#guestbook-enrollment",
  },
  confirmationPage: {
    waitFor: "#rewards_benefit_confirmed",
    messageTarget: "#rewards_benefit_confirmed",
    confirmationNumbers: "NA",
    contentChangeTarget: "NA",
    confirmationMessageContainer: "#guestbook-confirm",
  },
  cancellation: {
    waitFor: "div[aria-label='Cancel booking'] #sb-modalcontent svg[title='checkmark-outline']",
    cancellationNumber: "NA",
    confirmationNumber: "NA",
  }
};

export default Selectors;
